import React, { useMemo } from 'react';
import { View, Pressable, ScrollView, Platform, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';

const CHIP_IDS = [
  { id: 'all', labelKey: 'pages.prompts.modalityAll' },
  { id: 'new', labelKey: 'pages.prompts.modalityNew' },
  { id: 'image', labelKey: 'pages.prompts.modalityImage', outputType: 'image' },
  { id: 'video', labelKey: 'pages.prompts.modalityVideo', outputType: 'video' },
];

function PromptModalityFilter({ activeId = 'all', onChange }) {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const styles = useMemo(() => StyleSheet.create({
    scroll: {
      marginHorizontal: Platform.OS === 'web' ? 0 : -4,
    },
    row: {
      flexDirection: 'row',
      gap: 8,
      paddingVertical: 0,
    },
    chip: {
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: colors.border_color_secondary,
      backgroundColor: colors.solid_color_block,
      ...(Platform.OS === 'web' && { cursor: 'pointer' }),
    },
    chipActive: {
      backgroundColor: colors.text_color_primary,
      borderColor: colors.text_color_primary,
    },
    chipText: {
      color: colors.text_color_secondary,
    },
    chipTextActive: {
      color: colors.solid_color_primary,
    },
  }), [colors]);

  return (
    <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.scroll}>
      <View style={styles.row}>
        {CHIP_IDS.map(chip => {
          const isActive = activeId === chip.id;
          return (
            <Pressable
              key={chip.id}
              onPress={() => onChange?.(chip.id, chip)}
              style={[styles.chip, isActive && styles.chipActive]}
            >
              <Text
                size="xs"
                weight={isActive ? 'bold' : 'medium'}
                style={[styles.chipText, isActive && styles.chipTextActive]}
              >
                {t(chip.labelKey)}
              </Text>
            </Pressable>
          );
        })}
      </View>
    </ScrollView>
  );
}

export default React.memo(PromptModalityFilter);
